/**
 * @param {string} flagName e.g. is_blink
 * @param {(key: string) => string} t i18n translate function
 * @param {{ [flagName: string]: boolean }} [userFlags] used to explain a locked flag
 * @returns {string[]}
 */
export function getFlagTooltipTexts(flagName, t, userFlags) {
	const texts = []
	const key = flagName.split('is_')[1]
	texts.push(t(key))
	if (key === 'blink') texts.push('*' + t('drains_battery'))
	if (isFlagLocked(flagName, userFlags)) texts.push('*' + t('requires_like_btn'))
	return texts
}

/**
 * The maintenance button cannot be controlled while the like button is off
 * @param {string} flagName
 * @param {{ is_like_btn?: boolean }} [userFlags]
 * @returns {boolean}
 */
export function isFlagLocked(flagName, userFlags) {
	return flagName === 'is_maintenance_btn' && userFlags?.is_like_btn === false
}

/**
 * @returns {{ user_flags: object; sensor_flags: object }}
 */
export function getDefaultDeviceActionFlags() {
	const defaultFlags = {
		is_send_data: true,
		is_send_count: true,
		is_blink: false,
		is_like_btn: true,
		is_maintenance_btn: false,
		is_beacon: true,
	}
	return {
		user_flags: { ...defaultFlags },
		sensor_flags: { ...defaultFlags },
	}
}
